import PropTypes from 'prop-types';
import { useState } from 'react';

const PATTERN = "[0-9]{3}-[0-9]{3}-[0-9]{4}" // Regex pattern for phone numbers

/**
 * Phone number input component
 * 
 * @param {object} props
 * @param {string} props.id - component ID
 * @param {string} props.placeholder - placeholder text for input
 * @param {string} props.label - label text that appears above the input
 * @param {string} props.className - additional class added for styling
 */
const PhoneInput = ({ id, placeholder, label, className, initialValue }) => {
    const [value, setValue] = useState(null);
    const [lastKeyPressed, setLastKeyPressed] = useState();

    const handleKeyPress = (event) => {
        setLastKeyPressed(event.key);
    }

    const handleInput = (event) => {
        let currentValue = event.target.value;
        const len = currentValue.length

        // Add/remove dashes based on the current length of the phone number
        if (len === 3 || len === 7) {
            if (lastKeyPressed !== "Backspace") {
                currentValue += '-';
            } else {
                currentValue = currentValue.slice(0, -1);
            }
        }

        setValue(currentValue);
    }

    return (
        <>
            <label className='input-label' htmlFor={id}>{label}</label>
            <input
                type="tel"
                id={id}
                name={id}
                placeholder={placeholder}
                pattern={PATTERN}
                className={className}
                maxLength={12}
                value={value === null ? initialValue : value}
                onChange={(event) => handleInput(event)}
                onKeyDown={(event) => handleKeyPress(event)}
                autoComplete='off'
                title='Ex. 123-456-7890'
            />
        </>
    );
};

PhoneInput.propTypes = {
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default PhoneInput;